<div class="hunt-details-package-item">
  <div class="title">
    <hyperkit-typography variant="emphasized" size="md">
      {{ huntPackage?.title }}
    </hyperkit-typography>
  </div>

  @if (totalQueries > 0) {
    <hyperkit-segmented-progress-bar
      [segments]="queryStatusSegments"
      [showLabels]="true"
      size="small"
    ></hyperkit-segmented-progress-bar>
  }
</div>
